import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Check, X, ShieldAlert } from 'lucide-react';
import { toast } from 'sonner';

export default function ModerationPage() {
    const [data, setData] = useState({ questions: [], comments: [] });

    const load = async () => { const { data } = await api.get('/me/moderation'); setData(data); };
    useEffect(() => { load(); }, []);

    const moderateQ = async (qid, approve) => {
        try { await api.post(`/questions/${qid}/moderate`, { approve }); toast.success(approve ? 'Aprobado' : 'Rechazado'); load(); }
        catch (e) { toast.error(e?.response?.data?.detail || 'Error'); }
    };
    const moderateC = async (cid, approve) => {
        try { await api.post(`/comments/${cid}/moderate`, { approve }); toast.success(approve ? 'Aprobado' : 'Rechazado'); load(); }
        catch (e) { toast.error(e?.response?.data?.detail || 'Error'); }
    };

    return (
        <div className="space-y-4">
            <div>
                <h1 className="text-xl font-semibold tracking-tight flex items-center gap-2"><ShieldAlert className="h-5 w-5 text-red-600" />Moderación</h1>
                <p className="text-sm text-muted-foreground">Aprueba o rechaza preguntas y comentarios pendientes en tus anuncios.</p>
            </div>
            <Tabs defaultValue="questions">
                <TabsList>
                    <TabsTrigger value="questions">Preguntas ({data.questions.length})</TabsTrigger>
                    <TabsTrigger value="comments">Comentarios ({data.comments.length})</TabsTrigger>
                </TabsList>
                <TabsContent value="questions" className="mt-4 space-y-2" data-testid="mod-questions">
                    {data.questions.length === 0 && <div className="text-sm text-muted-foreground">Sin preguntas pendientes.</div>}
                    {data.questions.map(q => (
                        <div key={q.id} className="rounded-xl border bg-card p-3">
                            <div className="flex items-start justify-between gap-2">
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 mb-1">
                                        <Badge variant="outline">@{q.asker?.nickname}</Badge>
                                        {q.ad && <Link to={`/ad/${q.ad.id}`} className="text-xs text-red-600 hover:underline">Sobre: {q.ad.title}</Link>}
                                    </div>
                                    <div className="text-sm">{q.text}</div>
                                </div>
                                <div className="flex gap-2">
                                    <Button size="sm" onClick={() => moderateQ(q.id, true)} className="bg-red-600 hover:bg-red-700" data-testid={`approve-q-${q.id}`}><Check className="h-3 w-3 mr-1" />Aprobar</Button>
                                    <Button size="sm" variant="outline" onClick={() => moderateQ(q.id, false)} data-testid={`reject-q-${q.id}`}><X className="h-3 w-3 mr-1" />Rechazar</Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </TabsContent>
                <TabsContent value="comments" className="mt-4 space-y-2" data-testid="mod-comments">
                    {data.comments.length === 0 && <div className="text-sm text-muted-foreground">Sin comentarios pendientes.</div>}
                    {data.comments.map(c => (
                        <div key={c.id} className="rounded-xl border bg-card p-3">
                            <div className="flex items-start justify-between gap-2">
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 mb-1">
                                        <Badge variant="outline">@{c.author?.nickname}</Badge>
                                        {c.ad && <Link to={`/ad/${c.ad.id}`} className="text-xs text-red-600 hover:underline">Sobre: {c.ad.title}</Link>}
                                    </div>
                                    <div className="text-sm">{c.text}</div>
                                </div>
                                <div className="flex gap-2">
                                    <Button size="sm" onClick={() => moderateC(c.id, true)} className="bg-red-600 hover:bg-red-700" data-testid={`approve-c-${c.id}`}><Check className="h-3 w-3 mr-1" />Aprobar</Button>
                                    <Button size="sm" variant="outline" onClick={() => moderateC(c.id, false)} data-testid={`reject-c-${c.id}`}><X className="h-3 w-3 mr-1" />Rechazar</Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </TabsContent>
            </Tabs>
        </div>
    );
}
